export const ROUTER_SLUG_PARAM = 'slug';
export const ROUTER_ID_PARAM = 'id';
export const ROUTER_TICKER_PARAM = 'ticker';
